module.exports = __webpack_public_path__ + "img/edge_activites_balade_fermes.2da3b69b.svg";